import React, { useEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useClerk, useUser } from '@clerk/clerk-react';

export function AccountMenu() {
  const { user } = useUser();
  const clerk = useClerk();
  const location = useLocation();
  const menu = useRef(null);
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (menu.current) menu.current.open = false; }, [location.pathname, location.hash]);
  useEffect(() => {
    const close = event => { if (menu.current && !menu.current.contains(event.target)) menu.current.open = false; };
    const escape = event => { if (event.key === 'Escape' && menu.current?.open) { menu.current.open = false; menu.current.querySelector('summary')?.focus(); } };
    document.addEventListener('pointerdown', close);
    document.addEventListener('keydown', escape);
    return () => { document.removeEventListener('pointerdown', close); document.removeEventListener('keydown', escape); };
  }, []);
  if (!user) return null;
  const close = () => { if (menu.current) menu.current.open = false; };
  const signOut = async () => {
    setBusy(true); setError(null);
    try { await clerk.signOut({ redirectUrl: '/' }); }
    catch { setError('Could not sign out. Please try again.'); }
    finally { setBusy(false); }
  };
  return <details className="ff-account-menu" ref={menu}>
    <summary aria-label="Your account" className="ff-account-menu__trigger">
      {user.imageUrl ? <img src={user.imageUrl} alt="" className="ff-account-menu__avatar" width="36" height="36" /> : <span>{(user.firstName || 'A').slice(0, 1)}</span>}
    </summary>
    <div className="ff-account-menu__popover">
      <p className="ff-account-menu__name">{user.fullName || user.firstName || 'Your account'}</p>
      <Link to="/account" onClick={close}>Manage account</Link>
      <Link to="/account#alerts" onClick={close}>Alert settings</Link>
      <button type="button" onClick={signOut} disabled={busy}>{busy ? 'Signing out…' : 'Sign out'}</button>
      {error && <p role="alert" className="ff-account-menu__error">{error}</p>}
    </div>
  </details>;
}
